import qs from 'qs';

import { partnersApi } from '~/api';

import { isEmpty } from '~/utils';
import { handleLoadedPartners as defaultHandleLoadedPartners } from './partners.helpers';

const actionPrefix = (actionType) => `Partners/${actionType}`;

export const DEFAULT_PARTNER = { id: null };

export const SET_PARTNERS = actionPrefix`SET_PARTNERS`;
export const setPartners = (partners) => ({
  type: SET_PARTNERS,
  payload: partners,
});

export const loadPartners = (handleLoadedPartners) => (dispatch, getState) => {
  const state = getState();
  const {
    appointment: {
      draft: {
        shop: { id: storeId, name: shopName },
        partner,
        appointmentType: { id: appointmentTypeId },
        partnersGroupId,
      },
    },
  } = state;

  return partnersApi
    .fetch(
      `?${qs.stringify(
        {
          storeId,
          appointmentTypeId,
          groupId: isEmpty(partnersGroupId) ? undefined : partnersGroupId,
        },
        { skipNulls: true },
      )}`,
    )
    .then(({ partners }) => {
      if (partners.length > 1) {
        return [DEFAULT_PARTNER, ...partners];
      }
      return partners;
    })
    .then((partners) =>
      handleLoadedPartners
        ? handleLoadedPartners(partners)
        : defaultHandleLoadedPartners(dispatch, shopName, partner.id, partners),
    );
};
